import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Section from '../Atoms/Section';
import BigH1 from '../Atoms/BigH1';
import BigH2 from '../Atoms/BigH2';
import BigH3 from '../Atoms/BigH3';
import AnimatedSection from '../Components/AnimatedSection';
import BlueButton from '../Atoms/BlueButton';
import * as api from '../../api';

const Title = styled.div`
  width: 100%;
  border-bottom: 1px solid black;
  padding: 30px 0;
  text-align: left;
  padding-left: 40px;
`;

const StyledSection = styled(Section)`
  /* padding: 40px; */
`;

const WebinarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 20px;
  margin-top: 30px;
`;

const WebinarGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  width: 100%;
  max-width: 90%;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const WebinarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
`;

const VideoInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  padding: 20px;
  border-top: none;
  width: 100%;
`;

const VideoTitle = styled.h3`
  font-size: 18px;
  color: #333;
  width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: left;
  font-weight: bold;
  text-align: left;
  line-height: 1.5;
  min-height: calc(18px * 1.5 * 2);
`;

const VideoDescription = styled.p`
  font-size: 14px;
  color: #555;
  margin-top: 10px;
  width: 100%;
  text-align: left;
`;

const WebinarFrame = styled.iframe`
  width: 100%;
  height: 300px;
  border: none;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  gap: 10px;
`;

const PageButton = styled.button`
  padding: 8px 15px;
  background-color: ${props => props.active ? '#007bff' : '#f0f0f0'};
  color: ${props => props.active ? 'white' : 'black'};
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-weight: ${props => props.active ? 'bold' : 'normal'};
  transition: all 0.2s;
  
  &:hover {
    background-color: ${props => props.active ? '#007bff' : '#e0e0e0'};
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  width: 100%;
  max-width: 90%;
`;

const SearchInput = styled.input`
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 400px;
  font-size: 16px;
`;

const decodeHTML = (str) => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = str;
  return textArea.value;
};

const WebinairesArchive = () => {
  const [webinars, setWebinars] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const ITEMS_PER_PAGE = 6; // Same as interviews (6 per page)

  // useEffect(() => {
  //   const fetchWebinars = async () => {
  //     setLoading(true);
  //     try {
  //       // Use pageToken to get all videos (YouTube API only returns max 50 per request)
  //       let allWebinars = [];
  //       let nextPageToken = '';
  //       let moreVideosExist = true;
        
  //       while (moreVideosExist) {
  //         const response = await fetch(
  //           `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet&order=date&maxResults=50&pageToken=${nextPageToken}`
  //         );
          
  //         if (!response.ok) {
  //           throw new Error('Network response was not ok');
  //         }
          
  //         const data = await response.json();
          
  //         if (data.items) {
  //           // Filter for webinar videos
  //           const webinarVideos = data.items
  //             .filter(item => item.snippet.title.startsWith('Webinaire'))
  //             .map(item => ({
  //               id: item.id.videoId,
  //               title: decodeHTML(item.snippet.title),
  //               description: decodeHTML(item.snippet.description),
  //               embedUrl: `https://www.youtube.com/embed/${item.id.videoId}`,
  //               publishedAt: item.snippet.publishedAt,
  //               thumbnail: item.snippet.thumbnails.high.url
  //             }));
              
  //           allWebinars = [...allWebinars, ...webinarVideos];
  //         }
          
  //         // Check if there are more videos to fetch
  //         if (data.nextPageToken) {
  //           nextPageToken = data.nextPageToken;
  //         } else {
  //           moreVideosExist = false;
  //         }
  //       }
        
  //       // Sort by latest date
  //       allWebinars.sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
  //       setWebinars(allWebinars);
  //     } catch (error) {
  //       console.error('Error fetching webinars:', error);
  //       setError('Une erreur est survenue lors du chargement des webinaires.');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchWebinars();
  // }, [API_KEY]);

    useEffect(() => {
      const fetchVideos = async () => {
        try {
          setLoading(true);
          const {data : youtubeData} = await api.GetYoutubeData();
          
          if (youtubeData.webinaires) {
            setWebinars(youtubeData.webinaires);
          }
          setLoading(false);
        } catch (error) {
          console.error('Error fetching videos:', error);
        }
      };
  
      fetchVideos();
    }, []);

  // Filter webinars based on search term
  const filteredWebinars = webinars.filter(webinar => 
    webinar.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
    webinar.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate pagination
  const totalPages = Math.ceil(filteredWebinars.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const currentWebinars = filteredWebinars.slice(startIndex, endIndex);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Format publication date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  return (
    <div>
      <AnimatedSection direction="left">
        <Title>
          <BigH2>ARCHIVES WEBINAIRES</BigH2>
        </Title>
      </AnimatedSection>
      
      <StyledSection>
        <AnimatedSection direction="right" delay={300}>
          <BigH3 style={{ marginLeft: '40px', marginTop: '40px' }}>
            Tous nos webinaires, riches en astuces pratiques et ingénieuses
          </BigH3>
        </AnimatedSection>
        
        <FilterContainer>
          <SearchInput
            type="text"
            placeholder="Rechercher un webinaire..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // Reset to first page on search
            }}
          />
        </FilterContainer>
        
        {loading ? (
          <p style={{ textAlign: 'center', margin: '40px 0' }}>Chargement des webinaires...</p>
        ) : error ? (
          <p style={{ textAlign: 'center', margin: '40px 0', color: 'red' }}>{error}</p>
        ) : filteredWebinars.length === 0 ? (
          <p style={{ textAlign: 'center', margin: '40px 0' }}>Aucun webinaire trouvé pour cette recherche.</p>
        ) : (
          <>
            <WebinarContainer>
              <WebinarGrid>
                {currentWebinars.map((webinar) => (
                  <WebinarWrapper key={webinar.id}>
                    <WebinarFrame
                      src={webinar.embedUrl}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                    <VideoInfo>
                      <VideoTitle>{webinar.title}</VideoTitle>
                      <VideoDescription>
                        <strong>Publié le {formatDate(webinar.publishedAt)}</strong>
                        <br />
                        {webinar.description.length > 200
                          ? `${webinar.description.substring(0, 200)}...`
                          : webinar.description}
                      </VideoDescription>
                      <a 
                        href={`https://www.youtube.com/watch?v=${webinar.id}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ 
                          marginTop: '10px', 
                          color: '#007bff', 
                          textDecoration: 'none',
                          fontWeight: 'bold'
                        }}
                      >
                        Voir sur YouTube
                      </a>
                    </VideoInfo>
                  </WebinarWrapper>
                ))}
              </WebinarGrid>
            </WebinarContainer>
            
            {/* Pagination */}
            {totalPages > 1 && (
              <PaginationContainer>
                <PageButton 
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &laquo; Précédent
                </PageButton>
                
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(page => 
                    page === 1 || 
                    page === totalPages || 
                    (page >= currentPage - 1 && page <= currentPage + 1)
                  )
                  .map((page, index, array) => (
                    <React.Fragment key={page}>
                      {index > 0 && array[index - 1] !== page - 1 && (
                        <span style={{ margin: '0 5px' }}>...</span>
                      )}
                      <PageButton 
                        active={currentPage === page}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </PageButton>
                    </React.Fragment>
                  ))
                }
                
                <PageButton 
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Suivant &raquo;
                </PageButton>
              </PaginationContainer>
            )}
          </>
        )}
        
        <div style={{ textAlign: 'center', margin: '30px 0' }}>
          <a 
            href="https://www.youtube.com/playlist?list=PLNePeRvn_hvWjntoVT2eUtuiisO38iuCr" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <BlueButton>Voir la playlist YouTube complète</BlueButton>
          </a>
        </div>
      </StyledSection>
    </div>
  );
};

export default WebinairesArchive;